import { createRootRoute, createRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';

import { RootLayout } from '~layout';
import { trackException } from '~libs';

const RootErrorBoundary = ({ error }: { error: unknown }) => {
  useEffect(() => {
    trackException(error, { source: 'route.root' });
  }, [error]);
  return <div>Error: {String(error)}</div>;
};

const rootRoute = createRootRoute({
  loader: () => ({ crumb: 'Home' }),
  component: () => <RootLayout />,
  errorComponent: RootErrorBoundary,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/blasts' });
  },
});

export { indexRoute, rootRoute };
